// Rules for paying an invoice from the Invoices page.

// An invoice can be paid here when it is still unpaid, not voided, and tied to a job
// (the server prices the checkout from that job).
export const canPayInvoice = (invoice) =>
  Boolean(invoice && payJobIds(invoice).length && !invoice.paid_at && !invoice.voided_at);

// The jobs a payment covers: one for a per-job invoice, every company's job for a consolidated invoice.
export function payJobIds(invoice) {
  if (!invoice) return [];
  if (invoice.kind === 'consolidated') return invoice.job_ids || [];
  return invoice.job_id ? [invoice.job_id] : [];
}

export const payableLabel = (invoice) => {
  const due = invoice?.due_date ? new Date(invoice.due_date) : null;
  return due && due < new Date() ? 'Overdue' : 'Unpaid';
};
